<template>
<div></div>
    <!-- <wt-avatar v-drag :class="[classes, 'theme-bg', 'shadow']" :size="size">
        <wt-button :ripple="true">
            <wt-box class="wt-suspension-ball-trigger" >
                <slot></slot>
            </wt-box>
        </wt-button>
    </wt-avatar> -->
</template>

<script>
/**
 * 悬浮球组件
 * @vuedoc
 * @exports base/wt-suspension-ball
 * @example dependence
 */
// 组件class前缀
const prefixCls = 'wt-suspension-ball'

export default {
  props: {
    size: {
      type: String,
      default: '1rem'
    }
  },
  name: 'wt-suspension-ball',
  computed: {
    classes () {
      return `${prefixCls}`
    }
  }
}
</script>

<style lang="less">
.wt-suspension-ball{
    position:fixed;
    top:70%;
    right:0.5rem;
    z-index:999999;
    .wt-btn{
        width:100%;
        height:100%;
        padding:0!important;
        .mu-ripple-wrapper{
            z-index:-1;
        }
    }
    .wt-suspension-ball-trigger{
        width:100%;
        height:100%;
        box-sizing: border-box;
        padding:0.2rem;
        color:white;
    }
}
</style>
